<template>
  <Form ref="formValidate" :model="formValidate" :label-width="80">
    <FormItem label="调整水票" prop="point">
      <InputNumber v-model="formValidate.point" />
    </FormItem>
    <FormItem
      label="原因"
      prop="remark"
      :rules="[{ required: true, message: '请输入原因', trigger: 'blur' }]"
    >
      <Input type="textarea" v-model="formValidate.remark" />
    </FormItem>
  </Form>
</template>

<script>
import { Form, FormItem, InputNumber, Input } from "view-design";
export default {
  props: {
    obj: Object,
    that: Object,
    aaa: Object,
  },
  data() {
    const validator = (rule, value, callback) => {};
    return {
      formValidate: {
        point: 0,
        remark: "",
      },
    };
  },
  methods: {
    handleSubmit(name) {
      // console.log(this.obj, this.formValidate);
      let q = {
        id: this.obj.uid,
        uid: this.obj.uid,
        point: this.formValidate.point,
        remark: this.formValidate.remark,
      };
      let flg = false;

      this.$refs.formValidate.validate((Valid) => {
        console.log(this.formValidate.point);
        console.log(Valid);
        if (Valid) {
          $utils.api.load("/admin/api/user/point", q).then((res) => {
            if (res.code == 1) {
              // this.$Modal.remove();
              this.that.$refs.tablelist.ajaxData();
            }
          });
          flg = true;
        } else {
          this.$Message.warning("请输入原因");
          flg = false;
        }
      });
      return flg;
    },
  },
};
</script>

<style scoped></style>
